<app-modal-shell [showFooter]="true"
  [dismissLabel]="'general.cancel' | translate"
  (dismiss)="dismiss()">
  <div class="project-job-dialog-title"
    modalTitle>
    <h2>
      @if (item()) {
        {{ item().name }}
      } @else {
        {{ 'additionalInfo.addJob' | translate }}
      }
    </h2>
    @if (project()?.name; as projectName) {
      <p>{{ projectName }}</p>
    }
  </div>

  <form class="project-job-dialog"
    [formGroup]="formGroup"
    (ngSubmit)="save()">
    <div class="project-job-dialog-layout">
      <section class="project-job-dialog-sidebar">
        @if (hasSelectContractor()) {
          <section class="project-job-dialog-card">
            <div class="project-job-dialog-section-heading">
              <h3>{{ 'subcontractor.select' | translate }}</h3>
              <p>{{ 'siteProject.jobDialog.help.contractor' | translate }}</p>
            </div>

            <button class="project-job-dialog-pill-button"
              type="button"
              (click)="selectContractor()">
              @if (selectedContractor()) {
                {{ selectedContractor().name }}
              } @else {
                {{ 'subcontractor.select' | translate }}
              }
            </button>
          </section>
        }

        <section class="project-job-dialog-card">
          <div class="project-job-dialog-section-heading">
            <h3>{{ 'item.name' | translate }}</h3>
            <p>{{ 'siteProject.jobDialog.help.name' | translate }}</p>
          </div>

          <label class="project-job-dialog-field">
            <span>{{ 'item.name' | translate }}</span>
            <ion-item lines="none">
              <ion-input autocapitalize="on"
                formControlName="name"></ion-input>
            </ion-item>
          </label>
        </section>

        <section class="project-job-dialog-card">
          <div class="project-job-dialog-section-heading">
            <h3>{{ 'tickets.date' | translate }}</h3>
            <p>{{ 'siteProject.jobDialog.help.date' | translate }}</p>
          </div>

          <div class="project-job-dialog-date-range">
            <label class="project-job-dialog-field project-job-dialog-date-field">
              <span>{{ 'schedule.startDate' | translate }}</span>
              <app-select-day [name]="'schedule.startDate'"
                [minDate]="toDateInput(minDate)"
                [maxDate]="toDateInput(maxDate)"
                [value]="toDateInput(formGroup.get('start').value)"
                (changed)="onStartDateChange($event)"></app-select-day>
            </label>

            <label class="project-job-dialog-field project-job-dialog-date-field">
              <span>{{ 'schedule.endDate' | translate }}</span>
              <app-select-day [name]="'schedule.endDate'"
                [minDate]="toDateInput(minDate)"
                [maxDate]="toDateInput(maxDate)"
                [value]="toDateInput(formGroup.get('end').value)"
                (changed)="onEndDateChange($event)"></app-select-day>
            </label>
          </div>
        </section>

        <section class="project-job-dialog-card">
          <div class="project-job-dialog-section-heading">
            <h3>{{ 'room.setWorkTypes' | translate }}</h3>
            <p>{{ 'siteProject.jobDialog.help.areas' | translate }}</p>
          </div>

          <app-area-picker [areaRoots]="areaRoots()"
            [selectedRoom]="areaPickerRoom()"
            [disabled]="$safeNavigationMigration(project()?.areas?.length) > 0"
            (selected)="onAreaPickerSelected($event)"></app-area-picker>

          @if (getAreaSelectionEntries().length > 0) {
            <div class="project-job-dialog-area-list">
              @for (area of getAreaSelectionEntries(); track area.guid + '-' + area.id) {
                <button class="project-job-dialog-area-pill"
                  type="button"
                  [attr.aria-label]="'general.delete' | translate"
                  (click)="removeAreaSelection(area)">
                  <span>{{ area.label }}</span>
                  <ion-icon name="close-outline"></ion-icon>
                </button>
              }
            </div>
          }
        </section>
      </section>

      <section class="project-job-dialog-main">
        <section class="project-job-dialog-card project-job-dialog-card-fill">
          <div class="project-job-dialog-section-heading project-job-dialog-section-heading-row">
            <div>
              <h3>{{ 'sites.tickets' | translate }}</h3>
              <p>{{ 'siteProject.jobDialog.help.tickets' | translate }}</p>
            </div>

            <button class="project-job-dialog-pill-button project-job-dialog-pill-button-compact"
              type="button"
              [disabled]="selectedContractor() == null"
              (click)="addNewTicket()">
              {{ 'templates.addTicket' | translate }}
            </button>
          </div>

          <div class="project-job-dialog-summary-grid">
            @for (metric of summaryMetrics(); track metric.labelKey) {
              <article class="project-job-dialog-summary-card"
                [class.project-job-dialog-summary-card-info]="metric.tone === 'info'"
                [class.project-job-dialog-summary-card-success]="metric.tone === 'success'">
                <span>{{ metric.labelKey | translate }}</span>
                <strong>{{ metric.value }}</strong>
              </article>
            }
          </div>

          <div class="project-job-dialog-view-switch">
            <button class="project-job-dialog-view-switch-button"
              type="button"
              [class.project-job-dialog-view-switch-button-active]="isGroupView('type')"
              (click)="setGroupView('type')">
              {{ 'siteProject.jobDialog.view.byType' | translate }}
            </button>
            <button class="project-job-dialog-view-switch-button"
              type="button"
              [class.project-job-dialog-view-switch-button-active]="isGroupView('area')"
              (click)="setGroupView('area')">
              {{ 'siteProject.jobDialog.view.byArea' | translate }}
            </button>
          </div>

          <div class="project-job-dialog-ticket-list">
            @for (group of groupedTickets(); track group.key) {
              <section class="project-job-dialog-group">
                <header class="project-job-dialog-group-header">
                  <div class="project-job-dialog-group-title">
                    <h4>{{ group.title }}</h4>
                    <p>{{ group.subtitle }}</p>
                  </div>

                  @if (group.statuses.length > 0) {
                    <div class="project-job-dialog-group-statuses">
                      @for (status of group.statuses; track status.key) {
                        <span [class]="status.className">
                          {{ status.label | translate }} {{ status.count }}
                        </span>
                      }
                    </div>
                  }
                </header>

                @if (group.tickets.length > 0) {
                  <div class="project-job-dialog-group-tickets">
                    @for (ticketView of group.tickets; track ticketView.ticket.guid ?? $index) {
                      <button class="project-job-dialog-ticket"
                        type="button"
                        (click)="openTicket(ticketView.ticket)">
                        <div class="project-job-dialog-ticket-grid">
                          <div class="project-job-dialog-ticket-column project-job-dialog-ticket-column-primary">
                            <span class="project-job-dialog-ticket-name">{{ ticketView.name }}</span>
                            <span class="project-job-dialog-ticket-meta">{{ ticketView.areaPath }}</span>
                          </div>

                          <div class="project-job-dialog-ticket-column project-job-dialog-ticket-column-secondary">
                            <span class="project-job-dialog-ticket-assignee">{{ ticketView.assignee }}</span>
                            <span class="project-job-dialog-ticket-meta">{{ ticketView.hoursLabel }}</span>
                          </div>

                          <div class="project-job-dialog-ticket-column project-job-dialog-ticket-column-status">
                            <span [class]="ticketView.statusClass">
                              {{ ticketView.statusLabel | translate }}
                            </span>
                            <span class="project-job-dialog-ticket-deadline">{{ ticketView.deadlineLabel }}</span>
                          </div>
                        </div>
                      </button>
                    }
                  </div>
                } @else {
                  <div class="project-job-dialog-group-empty">
                    {{ 'siteProject.jobDialog.group.emptyArea' | translate }}
                  </div>
                }
              </section>
            }

            @if (formGroup.get('tickets').value.length === 0) {
              <div class="project-job-dialog-ticket-empty-state">
                <h4>{{ 'siteProject.jobDialog.empty.title' | translate }}</h4>
                <p>{{ 'siteProject.jobDialog.empty.description' | translate }}</p>
                <button class="project-job-dialog-pill-button"
                  type="button"
                  [disabled]="selectedContractor() == null"
                  (click)="addNewTicket()">
                  {{ 'item.add' | translate }}
                </button>
              </div>
            }
          </div>
        </section>
      </section>
    </div>
  </form>

  <div modalFooter>
    <button class="dialog-action dialog-action-secondary"
      type="button"
      (click)="dismiss()">
      {{ 'general.cancel' | translate }}
    </button>
    <button class="dialog-action dialog-action-primary"
      type="submit"
      [disabled]="!formGroup.valid"
      (click)="save()">
      {{ 'general.save' | translate }}
    </button>
  </div>
</app-modal-shell>